import React from 'react';
import styled from 'styled-components';
import {labels} from '../../../util/utils';
import OutputText from '@ey/canvascoreservices/OutputText';

function UserItem(props) {
	const {showMoreLabel, userName, noDataLoadedLabel} = props;
	const getUserLabel = () => {
		let user = {
			firstName: '',
			lastName: '',
			userName: ''
		};
		if (props.users && props.users.length > 0) {
			let firstUser = props.users.sort(function(a, b) {
				// because we were getting issue in mainttaining object sorting based on key so will have to sort here before show in UI
				return `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`);
			})[0];
			user.firstName = firstUser.firstName ? firstUser.firstName : '';
			user.lastName = firstUser.lastName ? firstUser.lastName : '';
			user.userName = `${user.firstName} ${user.lastName}`;
		}

		if (props.userName) {
			user.userName = props.userName;
		}

		user.count = props.users && props.users.length > 1 ? props.users.length - 1 : 0;
		return user;
	};

	let user = getUserLabel();

	return (
		<StyledUserItemSection className={'engagement-partner-wrap'}>
			<section className="partner-wrap">
				<OutputText body2 light ellipsis>{`${props.userLabel ? props.userLabel : labels.partnerLabel}:`}</OutputText>
				<OutputText body2 light ellipsis>
					{user.userName.trim() ? user.userName : noDataLoadedLabel ? noDataLoadedLabel : labels.notInvited}
				</OutputText>
			</section>
			{user.count > 0 && <OutputText body2 light ellipsis>{`+${user.count}`}</OutputText>}
		</StyledUserItemSection>
	);
}

export default UserItem;

const StyledUserItemSection = styled.span`
	display: flex;
	font-size: 1.2rem;
	.partner-wrap {
		display: flex;
		span {
			display: inline-block !important;
			max-width: 11rem;
		}
		margin-right: 1rem;
		.partner-name {
			margin-left: 0.5rem;
		}
	}
	&:hover {
		cursor: pointer;
		.icon-wrap {
			display: block;
		}
	}
	.ellipsis {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		display: inline-block;
	}
	.separator {
		margin: 0 0.5rem;
	}
`;
